// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from copy-filled.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function CopyFilledIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M1 16a1 1 0 0 1-.993-.883L0 15V5a1 1 0 0 1 .883-.993L1 4h3a1 1 0 0 1 1 1v8h4a1 1 0 0 1 1 1v1a1 1 0 0 1-.883.993L9 16H1ZM15 0a1 1 0 0 1 .993.883L16 1v10a1 1 0 0 1-.883.993L15 12H7a1 1 0 0 1-.993-.883L6 11V1a1 1 0 0 1 .883-.993L7 0h8Z"
      />
    </svg>
  );
}
